import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material';
import { XpoDialogModule } from '@xpo/ngx-core';
import { ConfirmComponent } from './confirm/confirm.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';

const dialogs = [
  // YOUR DIALOGS
  NotAuthorizedComponent,
  ConfirmComponent,
];

@NgModule({
  declarations: [...dialogs],
  imports: [
    // MATERIAL OR NGX CORE COMPONENTS
    XpoDialogModule,
    MatIconModule,
  ],
  exports: [...dialogs],
  entryComponents: [...dialogs],
})
export class DialogModule {}
